import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        login_token: Cookies.get('SSOSYSaccessToken') || localStorage.getItem('login_accessToken') || '',
        user_token: localStorage.getItem('user_accessToken') || '',
        userInfo: JSON.parse(localStorage.getItem('userInfo')) || null,
        new_user: false,
        isRequest: false,
        isFree: false,
        ttsTimes: localStorage.getItem("ttsTimes") || 0,
        bannerView: false,
        bannerImgHeight: 0,
    },
    mutations: {
        SET_TOKEN(state, token) {
            if (token.user_token) {
                state.user_token = token.user_token
                localStorage.setItem('user_accessToken', token.user_token)
            }

            if (token.login_token) {
                state.login_token = token.login_token
                localStorage.setItem('login_accessToken', token.login_token)
            }

        },
        SET_USER_INFO(state, userInfo) {
            state.userInfo = userInfo
            localStorage.setItem('userInfo', JSON.stringify(userInfo))
        },
        LOGOUT(state) {
            state.login_token = ''
            state.user_token = ''
            state.userInfo = null
            localStorage.removeItem('user_accessToken')
            localStorage.removeItem('login_accessToken')
            localStorage.removeItem('userInfo')
            Cookies.remove('SSOSYSaccessToken')
        },
        SET_NEW_USER(state, value) {
            state.new_user = value
        },
        SET_TTS_TIMES(state) {
            state.ttsTimes++;
            localStorage.setItem('ttsTimes', state.ttsTimes);
        },
        SET_BannerView(state, statue) {
            state.bannerView = statue
        },
        SET_BannerImgHeight(state, value) {
            state.bannerImgHeight = value
        }
    },
    actions: {
        //组件中使用 this.$store.dispatch('logout')
        login({ commit }, { token, userInfo }) {
            commit('SET_TOKEN', token)
            commit('SET_USER_INFO', userInfo)
        },
        logout({ commit }) {
            commit('LOGOUT')
        },
        setNewUser({ commit }, value) {
            commit('SET_NEW_USER', value)
        },
        setTimes({ commit }) {
            commit('SET_TTS_TIMES');
        },
        setToken({ commit }, token) {
            commit('SET_TOKEN', token);
        }
    },
    getters: {
        //组件中使用 this.$store.getters.isLoggedIn
        isLoggedIn: state => !!state.user_token,
        getUserInfo: state => state.userInfo,
        isNewUser: state => state.new_user,
        userToken: state => state.user_token,
        isFree: state => state.ttsTimes <= 3
    }
})